// @ts-nocheck

import React, { PureComponent } from 'react';
import { DEFAULT_DRUID_RECORD_LIMIT, commas } from '../../../support/utils';
type Props = {
  limit?: number;
};

class DataLimitWarning extends PureComponent<Props> {
  render() {
    const { limit = DEFAULT_DRUID_RECORD_LIMIT } = this.props;
    return (
      <span>
        {`We will load the top ${commas(
          limit
        )} records for each event or metric. Some low-volume records may be missing from the displayed analytics when looking at many different compare bys. In particular, data sorted by ascending values may be limited. To reduce the amount of data fetched, try adding additional filters or looking at a shorter time range. Alternatively, you can export your data using`}{' '}
        <a
          href="https://docs.branch.io/pages/exports/webhooks/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="webhook-link"
        >
          webhooks
        </a>{' '}
        or our{' '}
        <a
          href="https://docs.branch.io/pages/exports/api-v3/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="data-export-api-link"
        >
          Data Export API
        </a>
        {'.'}
      </span>
    );
  }
}

export default DataLimitWarning;
